export default __webpack_public_path__ + "static/media/Bitcoin.f83296a1.svg";